import { DateTime } from "luxon";
export const formatCondition = (condition) => condition.replace(/"false"/g, "false").replace(/"true"/g, "true");
export const timeAgo = (lastModificationDate) => {
    return DateTime.fromMillis(lastModificationDate).setLocale("en").toRelative();
};
export const flattenObject = (input) => {
    let output = {};
    for (const key in input) {
        if (input.hasOwnProperty(key)) {
            const element = input[key];
            if (typeof element == "object") {
                output = Object.assign(Object.assign({}, output), flattenObject(element));
            }
            else {
                output[key] = element;
            }
        }
    }
    return output;
};
//# sourceMappingURL=helpers.js.map